/**
 * ============================================================================
 * EL ARO — MAGNETIC EFFECT
 * ============================================================================
 *
 * Supports:
 *
 * 1. Buttons
 *    .js-magnetic
 *    .elaro-button-text
 *    .elaro-button-icon
 *
 * 2. Hero Product Card
 *    .js-magnetic
 *    .elaro-hero__product-tilt
 *
 * ============================================================================
 */

document.addEventListener('DOMContentLoaded', () => {

    'use strict';


    /*==========================================================================
      DEVICE CHECK
    ==========================================================================*/

    const supportsHover =
        window.matchMedia(
            '(hover: hover) and (pointer: fine)'
        ).matches;


    if (!supportsHover) {
        return;
    }


    /*==========================================================================
      MAGNETIC ELEMENTS
    ==========================================================================*/

    const elements =
        document.querySelectorAll(
            '.js-magnetic'
        );


    if (!elements.length) {
        return;
    }


    /*==========================================================================
      INITIALIZE EACH ELEMENT
    ==========================================================================*/

    elements.forEach(element => {

        /*
         * Prevent duplicate initialization.
         */

        if (
            element.dataset.magneticInitialized === 'true'
        ) {
            return;
        }


        element.dataset.magneticInitialized = 'true';


        /*======================================================================
          OPTIONS
        ======================================================================*/

        const strength =
            parseFloat(
                element.dataset.strength
            ) || 0.18;


        /*
         * Detect whether this is the hero product.
         */

        const isHeroProduct =
            element.matches(
                '.elaro-hero__product-tilt'
            );


        /*
         * Button-specific children.
         */

        const text =
            element.querySelector(
                '.elaro-button-text'
            );


        const icon =
            element.querySelector(
                '.elaro-button-icon'
            );


        /*======================================================================
          STATE
        ======================================================================*/

        let currentX = 0;
        let currentY = 0;

        let targetX = 0;
        let targetY = 0;

        let animationFrame = null;

        
        /*======================================================================
          ANIMATION
        ======================================================================*/

        function animate() {

            /*
             * Smooth interpolation.
             */

            currentX +=
                (targetX - currentX) * 0.15;


            currentY +=
                (targetY - currentY) * 0.15;


            /*------------------------------------------------------------------
              HERO PRODUCT
            ------------------------------------------------------------------*/

            if (isHeroProduct) {

                /*
                 * IMPORTANT:
                 *
                 * Only translate.
                 *
                 * NO:
                 * rotateX()
                 * rotateY()
                 * rotate()
                 * scale()
                 * perspective
                 */

                element.style.transform =
                    `translate3d(
                        ${currentX}px,
                        ${currentY}px,
                        0
                    )`;

            }


            /*------------------------------------------------------------------
              BUTTON
            ------------------------------------------------------------------*/

            else {

                /*
                 * Entire button moves slightly.
                 */

                element.style.transform =
                    `translate3d(
                        ${currentX * 0.18}px,
                        ${currentY * 0.18}px,
                        0
                    )`;


                /*
                 * Button text moves more.
                 */

                if (text) {

                    text.style.transform =
                        `translate3d(
                            ${currentX}px,
                            ${currentY}px,
                            0
                        )`;

                }


                /*
                 * Button icon moves the most.
                 */

                if (icon) {

                    icon.style.transform =
                        `translate3d(
                            ${currentX * 1.8}px,
                            ${currentY * 1.8}px,
                            0
                        )`;

                }

            }


            /*==================================================================
              STOP WHEN SETTLED
            ==================================================================*/

            const settled =
                Math.abs(targetX - currentX) < 0.05 &&
                Math.abs(targetY - currentY) < 0.05;


            if (!settled) {

                animationFrame =
                    requestAnimationFrame(
                        animate
                    );

            } else {

                animationFrame = null;

            }

        }


        /*======================================================================
          MOUSE MOVE
        ======================================================================*/

        element.addEventListener(
            'mousemove',
            event => {

                const rect =
                    element.getBoundingClientRect();


                /*
                 * Mouse position relative to center.
                 */

                const x =
                    event.clientX -
                    rect.left -
                    rect.width / 2;


                const y =
                    event.clientY -
                    rect.top -
                    rect.height / 2;


                /*
                 * Magnetic strength.
                 */

                targetX =
                    x * strength;


                targetY =
                    y * strength;


                /*
                 * Start animation if not already running.
                 */

                if (!animationFrame) {

                    animationFrame =
                        requestAnimationFrame(
                            animate
                        );

                }

            }
        );


        /*======================================================================
          MOUSE LEAVE
        ======================================================================*/

        element.addEventListener(
            'mouseleave',
            () => {

                /*
                 * Return to center.
                 */

                targetX = 0;
                targetY = 0;


                if (!animationFrame) {

                    animationFrame =
                        requestAnimationFrame(
                            animate
                        );

                }

            }
        );


        /*======================================================================
          REDUCED MOTION
        ======================================================================*/

        if (
            window.matchMedia(
                '(prefers-reduced-motion: reduce)'
            ).matches
        ) {

            element.style.transform = 'none';

            return;

        }

    });

});